// extracted by mini-css-extract-plugin
export default {"root":"nV4esSeW3lKgU2g2G6N6","placeHolderShimmer":"t4OjZSSvBjMZghbFGL6X"};